var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"flex flex-col"},[_vm._l((_vm.items),function(item){return [_c('o-menu-item',{key:item.path,attrs:{"item":item}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }